// extracted by css-extract-rspack-plugin
export default {"custom-label":"Presets-module__custom-label--nmg0y","customLabel":"Presets-module__custom-label--nmg0y"};